var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"loading-circle",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":_vm.viewBox}},[_c('path',{staticClass:"circle",attrs:{"d":_vm.path,"stroke-dasharray":_vm.stroke,"stroke-width":_vm.strokeWidth}})])}
var staticRenderFns = []

export { render, staticRenderFns }